
  export default {
    props: {
      isVideoReady: {
        type: Boolean,
        default: false,
      },
      source: {
        type: String,
        required: true,
      }
    },
  }
